import data from '@emoji-mart/data'
import i18n from '@emoji-mart/data/i18n/es.json'
import Picker from '@emoji-mart/react'
import { init } from 'emoji-mart'
import { Modal } from 'semantic-ui-react'

import { CUSTOM_EMOJIS } from 'images'

import './ReactionsPicker.css'

import type { FC } from 'react'

init({ custom: CUSTOM_EMOJIS, data })

interface ReactionsPickerProps {
  onSelect: (name: string) => void

  autoFocus?: boolean
  onClose?: () => void
  open?: boolean
}

const ReactionsPicker: FC<ReactionsPickerProps> = ({
  autoFocus = false,
  onClose = () => null,
  onSelect,
  open = true,
}) => {
  const handleOnSelect = ({ id }: { id: string }) => onSelect(id)

  return (
    <Modal
      basic
      className="ModalReactionsPicker"
      closeIcon="close"
      dimmer="blurring"
      onClose={onClose}
      open={open}
      size="mini"
    >
      <Modal.Content className="!p-0">
        <Picker
          autoFocus={autoFocus}
          custom={CUSTOM_EMOJIS}
          data={data}
          dynamicWidth
          i18n={i18n}
          onEmojiSelect={handleOnSelect}
        />
      </Modal.Content>
    </Modal>
  )
}

export default ReactionsPicker
